import React from "react";

import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { FormInputFieldCurrency } from "@components-shared/desktop/inputs";
import DesktopLayout from "@components-shared/desktop/layout/DesktopLayout";
import { Loader } from "@components/loader/desktop";
import { HeaderType } from "@data-types/layout/headerTypeEnum";
import { RegistrationFormData } from "@data-types/membership/registration";
import { usePartnerRegistrationStore } from "@state/context/membership/registration-types/PartnerRegistrationStoreContext";
import { observer } from "mobx-react";

import { OnBoardingFooter, OnBoardingSlider } from "../shared";

export default observer(function PartnerRegistrationTakeoverLimit() {
	const methods = useForm({ mode: "onChange" });
	const { handleSubmit } = methods;

	const { t } = useTranslation("registration");

	const { gamingLimitsData, isLoading, completeTakeoverWithLimit } =
		usePartnerRegistrationStore();

	return (
		<DesktopLayout
			headerType={HeaderType.EMPTY}
			mainClassName="at-PartnerRegistrationTakeoverLimit l--main l--main--grow"
		>
			<Loader isLoading={isLoading} />

			<section className="l--content l--content--full">
				<div className="l--content__main u-padd--reset">
					<div className="container container--med">
						<div className="card--onboarding card--shadowy">
							<OnBoardingSlider />

							<FormProvider {...methods}>
								<form
									className="card--onboarding__form"
									onSubmit={handleSubmit(
										(formData: RegistrationFormData) =>
											completeTakeoverWithLimit(
												formData.limitAmount
											)
									)}
								>
									<div className="card--onboarding__header">
										<div className="card--onboarding__title">
											{t("LUGAS_NO_EXISTING_LIMIT_TITLE")}
										</div>
									</div>

									<div className="card--onboarding__content">
										<div className="u-mar--bottom--med">
											{t("LUGAS_NO_EXISTING_LIMIT_INFO")}
										</div>

										<FormInputFieldCurrency
											name="limitAmount"
											className="form__field u-mar--bottom--med"
											inputClassName="input input--sml"
											label="registration:LIMIT_AMOUNT_LABEL"
											labelClassName="label--strong"
											placeholder="MEMBERSHIP.ACCOUNT_ACTIVATION.MONTHLY_DEPOSIT_LIMIT_PLACEHOLDER"
											pattern={{
												value: /^\d+(\.\d{1,2})?$/,
												message: t(
													"CASINO.BALANCE_TRANSFER.AMOUNT_VALIDATION_ERROR"
												),
											}}
											validate={{
												isEqual: (value: number) => {
													if (!gamingLimitsData) {
														return;
													}

													if (
														value >=
															gamingLimitsData.minLimit &&
														value <=
															gamingLimitsData.maxLimit
													) {
														return true;
													}

													return t("LIMIT_RANGE_ERROR", {
														0: gamingLimitsData.minLimit,
														1: gamingLimitsData.maxLimit,
													});
												},
											}}
											required
										/>
									</div>

									<button
										type="submit"
										className="at-partnerRegTakeoverLimitBtn btn btn--base btn--block btn--accent"
									>
										{t("OPEN_ACCOUNT")}
									</button>
								</form>
							</FormProvider>
						</div>

						<OnBoardingFooter isRegistration />
					</div>
				</div>
			</section>
		</DesktopLayout>
	);
});
